export default class Constants {
  public static readonly DEPLOYMENT_STATUS_NEW = 'STATUS_NEW';
  public static readonly DEPLOYMENT_STATUS_ACTIVE = 'STATUS_ACTIVE';
  public static readonly DEPLOYMENT_STATUS_SUSPENDED = 'STATUS_SUSPENDED';
  public static readonly SERVICE_SLUG_UPAFFILIATE = 'upaffiliate';

  public static readonly Color = {
    purple: '#B45DE3',
    blue: '#009CD3',
    cyan: '#01CDD3',
    red: '#d4484a'
  };

  public static readonly TRANSLATIONS_STORE = 'translations-store';
}
